import { Clock } from "lucide-react";
import { Countdown } from "@/components/ui/Countdown";
import { SlotsMeter } from "@/components/ui/SlotsMeter";

/**
 * Slim urgency strip: real deadline countdown + real slot availability.
 * Renders nothing once the offer is genuinely closed.
 */
export const DeadlineStrip = ({ availability, testId = "deadline-strip" }) => {
  if (!availability?.deadline) return null;

  if (!availability.is_open) {
    return (
      <div
        className="rounded-xl p-4"
        data-testid={`${testId}-closed`}
        style={{
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <p className="text-sm font-bold text-white">Free access is closed for now</p>
        <p className="mt-1 text-xs" style={{ color: "var(--gm-muted)" }}>
          {availability.after_deadline_note}
        </p>
      </div>
    );
  }

  return (
    <div
      className="rounded-xl p-4"
      data-testid={testId}
      style={{
        background: "rgba(224,31,38,0.08)",
        border: "1px solid rgba(224,31,38,0.4)",
      }}
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-white"
        >
          <Clock className="h-4 w-4" style={{ color: "#FF8A8E" }} aria-hidden="true" />
          Free access closes in
        </span>
        <Countdown
          target={availability.deadline}
          label="Free access"
          testId={`${testId}-countdown`}
          expiredText="Closed"
        />
      </div>

      <p className="mt-3 text-xs leading-relaxed" style={{ color: "var(--gm-muted)" }}>
        {availability.after_deadline_note}
      </p>

      {availability.total ? (
        <div className="mt-4">
          <SlotsMeter availability={availability} testId={`${testId}-slots`} />
        </div>
      ) : null}
    </div>
  );
};
